import { Link, useParams } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';

import { EntityCardGrid } from '../browse/EntityCardGrid';
import { PageContainer } from '../layout/PageContainer';
import { mobileSearchModels } from '../helpers/mobile-search-models';

export function ModelList() {
  const { make = '' } = useParams<{ make: string }>();
  const brandEntry = mobileSearchModels.find(([brandName]) => brandName === make);
  const models = brandEntry ? brandEntry.slice(1).filter(Boolean) : [];

  return (
    <PageContainer>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link to="/cars">All brands</Link>
        <Typography color="text.primary">{make}</Typography>
      </Breadcrumbs>
      <Typography variant="h4" gutterBottom>
        {make} models
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Pick a model to see its price history, engine specs, and estimated running costs.
      </Typography>
      <EntityCardGrid
        items={models}
        getHref={(model) => `/cars/${encodeURIComponent(make)}/${encodeURIComponent(model)}`}
        searchPlaceholder={`Search ${make} models...`}
        emptyMessage={`No models found for ${make}.`}
        itemNounPlural="models"
      />
    </PageContainer>
  );
}
